import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, firstValueFrom } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Customer, CustomerService } from '../../services/customer';
import { SalesOrderService } from '../../services/sales-order';
import { ProductService, SelectedProduct } from '../../services/products';
import { NotificationService } from '../../services/notification';
import { CartComponent } from '../../components/cart-component/cart-component';
import { SalesOrderSelectionService } from '../../services/sales-order-selection';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-view-sales-order',
  templateUrl: './view-sales-order-component.html',
  styleUrls: ['./view-sales-order-component.scss'],
  standalone: true,
  imports: [
    CartComponent,
    CommonModule
  ]
})
export class ViewSalesOrderComponent implements OnInit, OnDestroy {
  selectedCustomer: Customer | null = null;
  selectedProducts: SelectedProduct[] = [];
  disableEdit = true;
  private subscription!: Subscription;

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private salesOrderService: SalesOrderService,
    private notificationService: NotificationService,
    private salesOrderSelectionService: SalesOrderSelectionService
  ) { }

  async ngOnInit(): Promise<void> {
    // Subscribe to the selected item from SalesOrderSelectionService
    this.subscription = this.salesOrderSelectionService.selectedItem$.subscribe(async order => {
      if (!order) {
        this.notificationService.showMessage('No order selected');
        this.router.navigate(['/']);
        return;
      }

      try {
        // Fetch the order details using the order ID from the selection service
        const response = await firstValueFrom(this.salesOrderService.getSalesOrderById(order.order_id));
        if (response.status !== 'success') {
          this.notificationService.showMessage(response.message || 'Failed to fetch order');
          return;
        }

        const orderDetails = response.order;
        if (!orderDetails) return;

        // Set the selected products
        this.selectedProducts = orderDetails.lines.map(line => ({
          productId: line.product_id,
          quantity: line.quantity,
          price: line.price_unit
        }));

        // Fetch the customer details
        const customers = await firstValueFrom(this.customerService.get());
        this.selectedCustomer = customers.find(c => c.id === orderDetails.customerId) ?? null;

      } catch (err) {
        console.error('Failed to load sales order', err);
        this.notificationService.showMessage('Failed to load sales order');
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
